export default {
    isLoggedIn: null, 
};
